export default {
    isLoggedIn: null, 
};
